'use strict';

var $ = require('jquery');

function init() {
	var toolTip = $("#tool-tip");
	toolTip.hide();
	
	function displayToolTip(elem,adjust){
		toolTip.css({
			width: function() {
				return elem.data("version") == 'large' ? '450px' : '200px'  
			},
			fontSize: function() {
				return elem.data("version") == 'large' ? '11px' : '12px'
			}
		});
		
		var toolTipHeight = toolTip.height(); 
		var offset = elem.offset();
		
		toolTip.css({
			top: offset.top - (toolTipHeight + adjust.yAdjust), 
			left: offset.left - adjust.xAdjust
		}).fadeTo(250,1);
	}	
	
	function hideToolTip() {
		toolTip.hide().children(".tool-tip-inner").empty();
	}
	
	$("#calendar-listing a").bind("click", function() { $("#calendar-tool-tip").hide(); });
	
	$("#calendar-listing a").bind("mouseover mouseout", function(event){
		if ( event.type == 'mouseover'){
			$(this).next("ul").clone().appendTo("#tool-tip .tool-tip-inner");
			displayToolTip($(this),{xAdjust: 97, yAdjust: 45});
		} else {
			hideToolTip();
		}
	});
	
	
	var tooltipItem = null;
	
	$("#bill li").on('click',
		function(event) {
			/* tooltip is */
			if (this == tooltipItem){
				tooltipItem = null;
				hideToolTip();
			} else {
				tooltipItem = this;
				$('#tool-tip .tool-tip-inner').html( $(this).children(".content").clone() );
				displayToolTip($(this),{xAdjust: 101, yAdjust: 45});
			}
		}
	);
	$('#tool-tip').on('click', hideToolTip);
	
} // End toolTip Function

module.exports = {
	init : init
};